import { Form } from 'react-bootstrap';
import { IMaskInput } from 'react-imask';

interface BirthdayInputBoxProps {
  label: string;
  name: string;
  value: string;
  onChange: any;
  onBlur: any;
  isValid: boolean;
  isInvalid: boolean;
  errorFeedback: any;
}

export const BirthdayInputBox = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  isValid,
  isInvalid,
  errorFeedback,
}: BirthdayInputBoxProps) => (
  <Form.Group controlId={name} className="mb-3">
    <Form.Label>{label}</Form.Label>
    <IMaskInput
      placeholder="mm/dd/yyyy"
      mask="00/00/0000"
      value={value}
      onAccept={(value: string) => onChange({ target: { value } })}
      onBlur={onBlur}
      className={`form-control ${isValid ? 'is-valid' : ''} ${isInvalid ? 'is-invalid' : ''}`}
    />
    <Form.Control.Feedback type="invalid">{errorFeedback}</Form.Control.Feedback>
  </Form.Group>
);
